import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

/**
 * FieldError muestra el mensaje de validación inline de un campo. No renderiza
 * nada si no hay contenido (evita huecos en el formulario).
 */
export function FieldError({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) {
  if (!children) {
    return null;
  }
  return (
    <p className={cn("text-sm font-medium text-red-600", className)} {...props}>
      {children}
    </p>
  );
}
